import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const services = [
  { icon: 'ri-lightbulb-flash-fill', title: '広告戦略・プランニング', desc: '市場調査からターゲット分析まで、データドリブンな広告戦略を立案。ブランドの本質を捉えた効果的なコミュニケーション計画を提供します。', features: ['市場調査・競合分析', 'ターゲットペルソナ設計', 'メディアプランニング', 'クリエイティブブリーフ作成'], color: '#38BDF8', bg: 'linear-gradient(135deg, #E0F7FF, #BAE6FD)', emoji: '💡' },
  { icon: 'ri-palette-fill', title: 'ブランディング', desc: 'ロゴデザインからビジュアルアイデンティティまで、一貫したブランド世界観を構築します。', features: ['ロゴ・VI設計', 'ブランドガイドライン策定', 'パッケージデザイン', 'ブランドストーリー開発'], color: '#F472B6', bg: 'linear-gradient(135deg, #FFF0F7, #FBCFE8)', emoji: '🎨' },
  { icon: 'ri-global-fill', title: 'デジタルマーケティング', desc: 'SNS運用・SEO・リスティング広告など、デジタル領域での統合マーケティングを支援します。', features: ['SNSアカウント運用', 'SEO対策', 'リスティング広告運用', 'データ分析・レポーティング'], color: '#A3E635', bg: 'linear-gradient(135deg, #F3FFEA, #D9F99D)', emoji: '📱' },
  { icon: 'ri-megaphone-fill', title: 'PR・メディア対応', desc: 'プレスリリースの作成から、メディア露出の最大化まで包括的に対応します。', features: ['プレスリリース作成・配信', 'メディアリレーション構築', '取材・インタビューセッティング', '危機管理PR'], color: '#FB923C', bg: 'linear-gradient(135deg, #FFF7ED, #FED7AA)', emoji: '📣' },
  { icon: 'ri-video-fill', title: '映像・動画制作', desc: 'ブランドムービーからSNS動画まで、インパクトある映像コンテンツを制作します。', features: ['ブランドムービー制作', 'SNS向け動画制作', 'モーショングラフィックス', 'CM・TVCMプロデュース'], color: '#C084FC', bg: 'linear-gradient(135deg, #FAF5FF, #E9D5FF)', emoji: '🎬' },
  { icon: 'ri-layout-masonry-fill', title: 'クリエイティブ制作', desc: 'パンフレット・チラシ・バナーなど、あらゆる販促物のデザイン制作を行います。', features: ['パンフレット・冊子デザイン', 'WEBバナー制作', 'チラシ・DM制作', 'イベント装飾デザイン'], color: '#FBBF24', bg: 'linear-gradient(135deg, #FFFBEB, #FDE68A)', emoji: '✨' },
];

export default function ServicesPage() {
  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar />
      <section className="relative pt-36 pb-20 overflow-hidden" style={{ background: 'linear-gradient(135deg, #F472B6 0%, #FBBF24 100%)' }}>
        <div className="absolute top-10 right-10 w-40 h-40 bg-white/10 rounded-full" />
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 bg-white/20 text-white text-xs font-black px-4 py-2 rounded-full mb-6 uppercase tracking-wider backdrop-blur-sm">🎯 Services</div>
          <h1 className="text-4xl md:text-6xl font-black text-white mb-6 drop-shadow-sm">サービス一覧</h1>
          <p className="text-white/90 text-sm md:text-base max-w-xl mx-auto leading-relaxed font-medium">戦略からクリエイティブまで、ワンストップでブランドの成長を支援します！</p>
        </div>
      </section>
      <section className="py-24" style={{ background: '#F8F9FF' }}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((s) => (
              <div key={s.title} className="rounded-3xl p-8 flex flex-col hover:-translate-y-1 transition-transform" style={{ background: s.bg }}>
                <div className="text-4xl mb-4">{s.emoji}</div>
                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-2xl mb-5">
                  <i className={`${s.icon} text-2xl`} style={{ color: s.color }} />
                </div>
                <h3 className="font-black text-gray-900 text-xl mb-3">{s.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-1">{s.desc}</p>
                <ul className="space-y-2">
                  {s.features.map((f) => (
                    <li key={f} className="flex items-center gap-2 text-xs font-bold" style={{ color: s.color }}>
                      <i className="ri-check-line text-sm" />{f}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="py-20 bg-white text-center">
        <div className="max-w-2xl mx-auto px-6">
          <h2 className="text-3xl font-black text-gray-900 mb-4">まずはご相談ください🎉</h2>
          <p className="text-gray-500 text-sm mb-8 leading-relaxed font-medium">お客様のニーズに合わせた最適なプランをご提案します。</p>
          <Link to="/contact" className="inline-flex items-center gap-2 font-black px-8 py-3.5 rounded-full cursor-pointer hover:scale-105 transition-all whitespace-nowrap text-white" style={{ background: 'linear-gradient(135deg, #38BDF8, #F472B6)' }}>
            無料相談はこちら <i className="ri-arrow-right-up-line" />
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
